import RequestStatus from "../model/RequestStatus";
import SearchType, {BulkSearchProductRequest, ProductMatchPageResponse} from "../model/ProductMatch";

export const BULK_PRODUCT_DATA_QUERY_START = 'BULK_PRODUCT_DATA_QUERY_START';
export const BULK_PRODUCT_DATA_QUERY_SUCCESS = 'BULK_PRODUCT_DATA_QUERY_SUCCESS';
export const BULK_PRODUCT_DATA_QUERY_FAILED = 'BULK_PRODUCT_DATA_QUERY_FAILED';

export interface BulkProductDataQueryStartAction {
    readonly type: string,
    readonly requestStatus: RequestStatus,
    readonly countryCode: string,
    readonly keywords: string,
    readonly searchType: SearchType,
    readonly pageOffset: number,
    readonly filter?: Record<string, string>,
    readonly sortOrder?: string,
    readonly sortedColumnId?: string
}

export const setBulkProductDataQueryStart = (request: BulkSearchProductRequest): BulkProductDataQueryStartAction => ({
    type: BULK_PRODUCT_DATA_QUERY_START,
    requestStatus: RequestStatus.LOADING,
    countryCode: request.countryCode,
    keywords: request.keywords,
    searchType: request.searchType,
    pageOffset: request.pageOffset,
    filter: request.filters,
    sortOrder: request.sortOrder,
    sortedColumnId: request.sortedColumnId
});

export interface GetBulkProductDataQueryComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly productData: any;
}

export const getBulkProductDataQuerySuccessAction = (response: ProductMatchPageResponse): GetBulkProductDataQueryComplete => ({
    type: BULK_PRODUCT_DATA_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    productData: response
});

export const getBulkProductDataQueryFailedAction = (): GetBulkProductDataQueryComplete => ({
    type: BULK_PRODUCT_DATA_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    productData: null
});

